<app-ui-main-menu>
  <mat-card class="indications-page">
    <mat-card-header>
      <mat-card-title>Consulta de Indicações</mat-card-title>
    </mat-card-header>

    <div class="export-overlay" *ngIf="exporting">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="60"
      ></mat-progress-spinner>
      <span class="export-msg">Gerando CSV, aguarde...</span>
    </div>

    <mat-card-content class="page-content">
      <form
        [formGroup]="filters"
        class="filters"
        (ngSubmit)="applySearch()"
        novalidate
      >
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Pesquisar por</mat-label>
          <input
            matInput
            formControlName="search"
            placeholder="nome da conta, nome do paciente, e-mail da conta, nome do médico"
            (keyup.enter)="applySearch()"
          />
        </mat-form-field>

        <div class="searchBtn">
          <button mat-flat-button color="primary" type="submit">
            Pesquisar
          </button>
        </div>


        <div class="searchBtn">
          <button
            mat-flat-button
            type="button"
            class="export"
            (click)="exportCsv()"
            [disabled]="exporting || !hasPeriodFilter"
            matTooltip="O CSV respeita todos os filtros aplicados. É necessário informar um período de consulta para exportar."
          >
            <ng-container *ngIf="!exporting">Exportar CSV</ng-container>
            <ng-container *ngIf="exporting">Gerando...</ng-container>
          </button>
        </div>

      </form>

      <div class="more-filters-link">
        <button mat-button type="button" (click)="toggleFilters()" [color]="filtersApplied ? 'warn' : 'primary'" [disabled]="searchActive">
          <mat-icon>{{ filtersVisible ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ filtersVisible ? 'Menos filtros' : 'Mais filtros' }}
        </button>
      </div>

      <div *ngIf="filtersVisible" class="filters-panel" [class.panel-disabled]="searchActive">
        <div class="filters-panel-grid">

          <mat-form-field
            appearance="outline"
            matTooltip="Período de data de consulta (máx. 30 dias)"
            matTooltipPosition="above"
          >
            <mat-label>Período de consulta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Data inicial"
                [value]="filters.value.dateFrom"
                (dateChange)="filters.patchValue({ dateFrom: $event.value, dateTo: null })"
              />
              <input
                matEndDate
                placeholder="Data final"
                [value]="filters.value.dateTo"
                [min]="filters.value.dateFrom"
                [max]="maxDateTo"
                (dateChange)="filters.patchValue({ dateTo: $event.value })"
              />
            </mat-date-range-input>
            <mat-hint>Máximo 30 dias</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error *ngIf="rangeError">O período não pode ultrapassar 30 dias</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Status da indicação</mat-label>
            <mat-select [formControl]="$any(filters.controls.status)">
              <mat-option *ngFor="let s of indicationStatuses" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Laudo</mat-label>
            <mat-select [formControl]="$any(filters.controls.hasDocument)">
              <mat-option *ngFor="let o of hasDocumentOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Médico</mat-label>
            <mat-select [formControl]="$any(filters.controls.doctorId)">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option *ngFor="let d of doctors" [value]="d.id">{{ d.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Anexos</mat-label>
            <mat-select [formControl]="$any(filters.controls.hasFilesAttachment)">
              <mat-option *ngFor="let o of hasFilesAttachmentOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Nota Fiscal</mat-label>
            <mat-select [formControl]="$any(filters.controls.invoiceStatus)">
              <mat-option *ngFor="let o of invoiceStatusOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

      </div>

      <div class="selection-bar" *ngIf="selection.selected.length > 0">
        <span>{{ selection.selected.length }} indicação(ões) selecionada(s)</span>
        <button
          mat-flat-button
          type="button"
          color="accent"
          [disabled]="emitting"
          (click)="emitSelectedInvoices()"
        >
          {{ emitting ? 'Emitindo...' : 'Emitir NFs' }}
        </button>
      </div>

      <app-loading *ngIf="loading"></app-loading>

      <ng-container *ngIf="!loading">
        <div *ngIf="dataSource.data.length === 0" class="empty">
          <h3>Nenhum conteúdo disponível</h3>
        </div>

        <div *ngIf="dataSource.data.length > 0" class="table-shell">
          <div class="table-scroll" tabindex="0">
            <table mat-table [dataSource]="dataSource" class="wide-table">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    [checked]="isAllSelected()"
                    [indeterminate]="isIndeterminate()"
                    (change)="toggleAllRows($event.checked)">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let r">
                  <mat-checkbox
                    [checked]="selection.isSelected(r)"
                    (change)="selection.toggle(r)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="indicationId">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Identificador da indicação"
                    >Indicação</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">{{ r.id }}</td>
              </ng-container>

              <ng-container matColumnDef="hasFilesAttachment">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title">Anexos</span>
                </th>
                <td mat-cell *matCellDef="let r">
                  <ng-container *ngIf="r?.files.length; else noDoc">
                    <mat-icon color="primary">check</mat-icon>
                  </ng-container>
                  <ng-template #noDoc>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="patientName">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Nome completo do paciente"
                    >Paciente</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.patient?.name || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="patientCpf">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="CPF do paciente"
                    >CPF Paciente</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.patient?.cpf || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="patientMobile">
                <th mat-header-cell *matHeaderCellDef><span class="col-title"
                    matTooltip="Número de telefone do paciente">Telefone
                    Paciente</span></th>
                <td mat-cell *matCellDef="let r">
                  {{ formatPhone(r.patient?.mobile) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="scheduleDate">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Data do último agendamento da indicação"
                    >Agendamento</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.schedules?.[0]?.date ? (r.schedules[0].date | date:'DD/MM/YYYY') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="doctorName">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Nome do médico do agendamento"
                    >Médico</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.schedules?.[0]?.doctor?.name || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="indicationStatus">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Status geral da indicação"
                    >Status Agendamento</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">{{ r.status }}</td>
              </ng-container>

              <ng-container matColumnDef="scheduleStatus">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Status da última consulta/agendamento da indicação"
                    >Status Consulta</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.schedules?.[0]?.status || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="paymentDate">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Data da transação mais recente da indicação"
                    >Pagamento</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{
                    r.indication.paymentDate
                      ? (r.indication.paymentDate | date : "DD/MM/YYYY")
                      : "-"
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="benefit">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Benefício pleiteado"
                    >Benefício</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">{{ r.indicationBenefit?.name || "-" }}</td>
              </ng-container>

              <ng-container matColumnDef="hasDocument">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Quantidade de laudos ativos anexados às consultas da indicação"
                    >Laudo</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{
                    !r.documentCount
                      ? "Não Entregue"
                      : r.documentCount === 1
                      ? "1 Laudo"
                      : r.documentCount + " Laudo(s)"
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="procedure">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Procedimento/Especialidade (cardiologia, ortopedia, etc.)"
                    >Procedimento</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.indication.procedure || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Nome da conta (advogado/escritorio)"
                    >Nome Conta</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.user?.account?.name || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accountEmail">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="E-mail principal da conta (advogado/escritorio)"
                    >E-mail conta</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.user?.account?.email || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="userEmail">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="E-mail do usuário"
                    >Criado por</span
                  >
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.user?.email || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nfeId">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Número da Nota Fiscal Eletrônica">NFe</span>
                </th>
                <td mat-cell *matCellDef="let r">
                  <ng-container *ngIf="r.invoice?.nfeId; else noNfe">
                    <ng-container *ngIf="r.invoice?.pdfUrl; else nfeOnly">
                      <a [href]="r.invoice.pdfUrl" target="_blank" rel="noopener">{{ r.invoice.nfeId }}</a>
                    </ng-container>
                    <ng-template #nfeOnly>{{ r.invoice.nfeId }}</ng-template>
                  </ng-container>
                  <ng-template #noNfe>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="nfeStatus">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Status da Nota Fiscal">Status NF</span>
                </th>
                <td mat-cell *matCellDef="let r">
                  {{ r.invoice?.statusNf || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let r" class="actions">
                  <button
                    mat-mini-fab
                    color="primary"
                    *ngIf="isAttachable(r)"
                    matTooltip="Anexar laudo manualmente"
                    (click)="openAttachReport(r)"
                  >
                    <fa-icon icon="paperclip" class="paperclip"></fa-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator
            [length]="total"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100, 500]"
            (page)="onSearch($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
